export const FEATURE_SEARCH_SELECTION = "SEARCH_SELECTION";
